'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').service('DepositosService', function($http, RestService) {
  return {
    get URL() {
      return `${SERVER + API_VERSION }depositos/`;
    },

    list: function(filters) {
      const params = !filters ? {} : {
        descricao: filters.descricao || null,
        tipo_deposito: (filters.tipoDeposito || {}).id || null
      };

      return RestService.getFromUrl(this.URL, params);
    },

    save: function(deposito) {
      const glebas = deposito.glebas.map(function(gleba) {
        return gleba.id;
      });
      const propriedades = deposito.propriedades.map(function(propriedade) {
        return propriedade.id;
      });
      return $http({
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        url: `${this.URL}${deposito.cd_deposito}`,
        data: {
          deposito: {
            ino_st_uso: deposito.em_uso ? 'S' : 'N',
            propriedade_ids: propriedades,
            gleba_ids: glebas
          }
        }
      });
    },

    get: function(id) {
      const url = `${this.URL}${id}`;
      return $http.get(url);
    },

    hasDepositInUse: function(id) {
      return $http.get(`${this.URL}${'/has_deposit_in_use'}`, id);
    }
  };
});
